import React, { createRef } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

class TypewriterMarkdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayedText: "",
      done: false,
    };
    this.index = 0;
    this.interval = null;
    this.finalRef = createRef();
  }

  componentDidMount() {
    const { richtext, speed = 30 } = this.props;
    this.interval = setInterval(() => {
      if (this.index < richtext.length) {
        this.setState(
          (prevState) => ({
            displayedText: prevState.displayedText + richtext.charAt(this.index),
          }),
          () => {
            if (this.finalRef.current) {
              this.finalRef.current.scrollIntoView({ behavior: "smooth" });
            }
          }
        );
        this.index++;
      } else {
        clearInterval(this.interval);
        this.setState({ done: true });
      }
    }, speed);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { displayedText, done } = this.state;

    return (
      <div
        className="typewriter-text-div"
      >
        {done ? (
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            linkTarget="_blank"
            children={displayedText}
            className="typewriter-text"
          />
        ) : (
          <pre >
            {displayedText}
            <span ref={this.finalRef} />
          </pre>
        )}
      </div>
    );
  }
}

export default TypewriterMarkdown;